<div>
  <mat-date-range-input [rangePicker]="picker">
    <input matStartDate [ngModel]="value.from" (ngModelChange)="fromDateChanged($event)">
    <input matEndDate [required]="false" [ngModel]="value.to" (ngModelChange)="toDateChanged($event)">
  </mat-date-range-input>
  <mat-icon (click)="picker.open()">calendar_month</mat-icon>
  <mat-date-range-picker #picker [touchUi]="coreConfiguration.isMobile"></mat-date-range-picker>
</div>
